export const API_TABLE_ROWS_PER_PAGE = 10;
export const API_TABLE_ROWS_PER_PAGE_OPTIONS = [10,20,30,50,100];